import Seo from "@/components/Seo";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Hero from "@/sections/Hero";
import Marquee from "@/sections/Marquee";
import Services from "@/sections/Services";
import Journey from "@/sections/Journey";
import HowItWorks from "@/sections/HowItWorks";
import Pricing from "@/sections/Pricing";
import CaseStudyTeaser from "@/sections/CaseStudyTeaser";
import Support from "@/sections/Support";
import About from "@/sections/About";
import CtaSection from "@/sections/CtaSection";
import ContactForm from "@/sections/ContactForm";

export default function Home() {
  return (
    <div data-testid="home-page">
      <Seo
        title="SourceWorld Automations | Websites, Google Visibility & Automation"
        description="We help local businesses get found online, capture more enquiries and automate follow-up with professional websites, Google visibility and smart automation."
      />
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Services />
        <Journey />
        <HowItWorks />
        <Pricing />
        <CaseStudyTeaser />
        <Support />
        <About />
        <CtaSection />
        <ContactForm />
      </main>
      <Footer />
    </div>
  );
}
